import Navbar from "./Navbar";
import { Grid, Toolbar, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import EventData from "./EventPosts";
import whatsapplogo from "./resource/WhatsAppButtonGreenSmall.svg";
function EventPostIndividual() {
  const { id } = useParams();
  const post = EventData.find((post) => post.id === id);

  // Safety check
  if (!post) {
    return <h2 style={{ textAlign: "center" }}>Event not found</h2>;
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      sx={{ minHeight: "100vh" }}
    >
      {/* Navbar */}
      <Grid item xs={12} sx={{ width: "100%" }}>
        <Toolbar>
          <Navbar />
        </Toolbar>
      </Grid>

      {/* Content */}
      <Grid
        container
        direction="column"
        alignItems="center"
        textAlign="center"
        spacing={3}
        sx={{ px: 2 }}
      >
        {/* Title */}
        <Grid item xs={12}>
          <p className="normalPHead" style={{ textAlign: "center", color:"black"}}>{post.title}</p>
        </Grid>

        {/* Responsive Image */}
        <Grid item xs={12}>
          <Box
            component="img"
            src={post.image}
            alt="Upcoming event"
            sx={{
              width: {
                xs: "100%", // phones
                sm: "80%",  // tablets
                md: "60%",  // laptops
                lg: "100%",  // big screens
              },
              maxWidth: 800,
              height: "auto",
              borderRadius: 2,
            }}
          />
        </Grid>

        {/* Optional event info */}
        <Grid item xs={12}>
          <p style={{textAlign:"center", fontSize:"30px", color:"black"}}>{post.content}</p>
          <p style={{textAlign:"center", fontSize:"30px", color:"black"}}>{post.price}</p>
        </Grid>
      </Grid>
            <a
              aria-label="Chat on WhatsApp"
              href="https://wa.me/+6591124691?text=Hi%2C%20I%20would%20like%20to%20find%20out%20more%20about%20the%20courses%20%20offered%20by%20Quindicesima%21"
            >
                    <img
                    alt="Chat on WhatsApp"
                    src={whatsapplogo}
                    style={{ position: "fixed", bottom: 5, right: 5 }}
                  />
            </a>
    </Grid>
  );
}

export default EventPostIndividual;